import React from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";
import { testLocator } from "@/lib/helpers/test-locator";

import images from "../../../utils/images";

import "./styles.scss";

const ImageFullPreview = ({ close, contentType, url, wideView }) => {
  let imgClass = wideView ? "ImageFullPreview__img-wpr-wide" : "ImageFullPreview__img-wpr";

  return (
    <div className="ImageFullPreview">
      <div className="ImageFullPreview__inner position-absolute">
        <div className={`${imgClass} p-2`}>
          <img
            alt="close"
            className="mb-2 ImageFullPreview__close-btn"
            onClick={close}
            role="button"
            src={images("./icons/cross.svg")}
            {...getAutomationDataAttr("insurance-preview-close-button")}
            {...testLocator("image-full-preview-close-button")}
          />

          <div className="w-100 h-100" data-private>
            {((contentType && contentType.includes("pdf")) || contentType === undefined) && (
              <object
                className="img-fluid"
                data={url}
                height="100%"
                width="100%"
                {...testLocator("image-full-preview-content")}
              />
            )}
            {contentType && !contentType.includes("pdf") && (
              <img
                className="img-fluid"
                height="100%"
                src={url}
                width="100%"
                {...testLocator("image-full-preview-content")}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageFullPreview;
